import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

/**
 * @prop theme - Predefined style (options: primary, secondary, success, info, warning, danger, muted).
 * @prop layout - Predefined element size (options: sm, md, lg)
 * @prop outline - Outline element with the border (optional)
 *
 * @cssprop [--text-primary=var(--info)] - Text color.
 * @cssprop [--background-primary=var(--info)] - Background color for element without outline attribute.
 * @cssprop [--border-color=var(--info)] - Border color for element with outline attribute.
 * @cssprop [--font-size-primary=16px] - Text size depending on layout.
 *
 * @slot - Default slot content.
 */
export default class Label extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    outline: { type: Boolean, reflect: true },
    theme: { type: String, reflect: true },
    layout: { type: String, reflect: true },
  };

  constructor() {
    super();
    this.theme = 'info';
    this.layout = 'sm';
  }

  render() {
    return html` <slot></slot> `;
  }
}

customElements.get('ef-label') || customElements.define('ef-label', Label);
